export default __webpack_public_path__ + "static/media/Toilet.270225db.png";